import template from './mergeFields.template.html';

export default {
  template,
  bindings: {
    mergeFields: '<',
    isOnPdfFillRoute: '<',
    binding: '<',
    mappableFields: '<',
    onFinished: '&',
    field: '<'
  },
controller: class controller {
    constructor($timeout, $mdMedia, $mdMenu) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      var ctrl = this;
      ctrl.$mdMedia = $mdMedia;
      ctrl.isMenuVisible = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      this.initialize = function () {
        ctrl.mergeProperties = ctrl.mergeFields;
        ctrl.binding = ctrl.binding;
        ctrl.field = ctrl.field;
        ctrl.firstLevel = true;
        ctrl.isMenuVisible = false;
        ctrl.searchTerm = '';
      };

      ctrl.back = function ($event) {
        $event.stopPropagation();
        ctrl.firstLevel = true;
        ctrl.mergeProperties = ctrl.mergeFields;
      };

      ctrl.close = function ($event) {
        $event.stopPropagation();
        ctrl.isMenuVisible = false;
        $mdMenu.destroy();
      };

      ctrl.openSubMenu = function (property) {
        ctrl.firstLevel = false;
        ctrl.mergeProperties = property.value;
        ctrl.searchTerm = '';
      };

      ctrl.addPropertyCode = function (binding, property) {
        ctrl.onFinished({ binding: binding, property: property, field: ctrl.field });
        $mdMenu.destroy();
      };

      ctrl.getFieldShortName = function (name, index) {
        var _name = name.split(' - ');
        return _name[index] !== '' ? _name[index] : _name[index - 1];
      };
      ctrl.isAddedField = function (binding) {
        if (binding !== null) {
          var b = parseInt(binding.replace('property', ''));
          var f = _.find(ctrl.mappableFields, function (item) {
            return item.id === b;
          });
          return f !== undefined;
        }
      };
      ctrl.showMenu = function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        ctrl.isMenuVisible = true;
        $timeout(function () {
          angular.element('md-menu.mappable-button .md-button').triggerHandler('click');
        });
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = function () {
        this.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = function (changes) {};

      /*
       * Execute when component is not necessary anymore
       * --------------------------------------------------------------------------------
       */
      this.$onDestroy = function () {};
    }
  }
};
